import React from 'react';
import { Tooltip } from '@mui/material';
import type { WorkflowStatusId } from 'types/workflow/workflow-status';
import { useIntl } from 'react-intl';
import WorkflowStatusIconBadge from './WorkflowStatusIconBadge';

type WorkflowStatusIconProps = {
  status: WorkflowStatusId;
  size?: number;
};

const WorkflowStatusIcon: React.FC<WorkflowStatusIconProps> = ({ status, size = 22 }) => {
  const intl = useIntl();
  const label = intl.formatMessage({ id: `sidebar.workflow.status${status}`, defaultMessage: `Status ${status}` });

  return (
    <Tooltip title={label} placement="top">
      <span aria-label={label}>
        <WorkflowStatusIconBadge status={status} size={size} />
      </span>
    </Tooltip>
  );
};

export default WorkflowStatusIcon;
